var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmailIco(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 12,
    viewBox: "0 0 16 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.33337 2.6665L4.79594 4.97488C4.9957 5.10805 5.09558 5.17464 5.20364 5.22181C5.29955 5.26368 5.40006 5.29411 5.50309 5.31248C5.61917 5.33317 5.73921 5.33317 5.9793 5.33317H10.0208C10.2609 5.33317 10.3809 5.33317 10.497 5.31248C10.6 5.29411 10.7005 5.26368 10.7964 5.22181C10.9045 5.17464 11.0044 5.10805 11.2041 4.97488L14.6667 2.6665M4.53337 11.3332H11.4667C12.5868 11.3332 13.1469 11.3332 13.5747 11.1152C13.951 10.9234 14.257 10.6175 14.4487 10.2412C14.6667 9.81333 14.6667 9.25328 14.6667 8.13317V3.8665C14.6667 2.7464 14.6667 2.18635 14.4487 1.75852C14.257 1.3822 13.951 1.07624 13.5747 0.884491C13.1469 0.666504 12.5868 0.666504 11.4667 0.666504H4.53337C3.41327 0.666504 2.85322 0.666504 2.42539 0.884491C2.04907 1.07624 1.74311 1.3822 1.55136 1.75852C1.33337 2.18635 1.33337 2.7464 1.33337 3.8665V8.13317C1.33337 9.25328 1.33337 9.81333 1.55136 10.2412C1.74311 10.6175 2.04907 10.9234 2.42539 11.1152C2.85322 11.3332 3.41327 11.3332 4.53337 11.3332Z",
    stroke: "#D1D1D1",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailIco);
export default __webpack_public_path__ + "static/media/email-ico.4a06623973dcb3a1d569bd384c616e5b.svg";
export { ForwardRef as ReactComponent };